<div class="reliance">
    <div class="reliance-title-container">
        @if (showIcon()) {
            <img src="assets/icon/circle-flash-white.svg" />
        }
        <span class="body-medium">{{ title() }}</span>
    </div>
    <web-fading-span
        [value]="value() || (value() === 0 && autorizeZero() ? value() : '-')"
        [autorizeZero]="autorizeZero()"
        valueClass="grey body-medium number"
        suffix="%"
        suffixClass="grey body-medium number"
    ></web-fading-span>
</div>
@if (showBar()) {
    <div class="ratio-bar">
        <div class="progression" [style.width.%]="value()"></div>
    </div>
}
